import Phaser from 'phaser'

export class Foreground extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y)
    scene.add.existing(this)
    this.createForeground()
  }

  createForeground() {}

  destroy(fromScene?: boolean): void {
    this.removeAll(true)
    super.destroy(fromScene)
  }
}
